import * as React from "react"
// eslint-disable-next-line import/no-cycle
import components from "@components/strapi"
import { PageProps } from "gatsby"

const RepeatableComponent = ({
    repeatable_component: repeatableComponent,
    location,
    relatedArticles
}: Pick<PageProps, "location"> & GatsbyTypes.RepeatableComponentFragment & {relatedArticles: any}) => (
    repeatableComponent?.components && repeatableComponent.components.map((section) => {
        const Component = components[`${section?.__typename}`]
        const componentProps = { ...section, location, relatedArticles }

        if (!Component) {
            return process.env.NODE_ENV !== "production" ? <p key={`${section?.id}_${section?.__typename}`}>
                Missing section
                {section?.__typename}
            </p> : null
        }

        return <React.Fragment key={`${section?.id}_${section?.__typename}`}>
            <Component {...componentProps} />
        </React.Fragment>
    })
)

export default RepeatableComponent
